import React, { Component } from 'react';
import Clients from './Clients';

class SupplierPage extends Component {
	render () {
		return <Clients type="supplier" />
	}
}

export default SupplierPage;



// WEBPACK FOOTER //
// ./containers/SupplierPage.js